import React from "react";
import { BsGithub, BsArrowUpRight } from "react-icons/bs";

function initials(title = "") {
  return title
    .replace(/[^a-zA-Z0-9 ]/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}

function ProjectCover({ title, tech = [] }) {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden bg-gradient-to-br from-accent/25 via-bg-soft to-bg">
      <div className="absolute inset-0 grid-backdrop opacity-40" />
      <div className="relative flex flex-col items-center gap-3 px-6 text-center">
        <span className="grid h-16 w-16 place-items-center rounded-2xl border border-line bg-white/5 font-display text-2xl font-bold text-ink shadow-glow">
          {initials(title)}
        </span>
        <span className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-ink-faint">
          {tech[0] || "Project"}
        </span>
      </div>
    </div>
  );
}

function ProjectCards({ project }) {
  const { title, image, description, tech = [], github, demo, featured } = project;
  const hasDemo = demo && demo.trim() && demo.trim() !== "...";

  return (
    <article
      className={`card-surface group flex h-full w-full flex-col overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-accent/40 hover:shadow-glow ${
        featured ? "lg:flex-row" : ""
      }`}
    >
      <div
        className={`relative shrink-0 overflow-hidden border-b border-line bg-[#0d0d16] ${
          featured
            ? "aspect-[16/10] lg:aspect-auto lg:w-1/2 lg:border-b-0 lg:border-r"
            : "aspect-[16/10]"
        }`}
      >
        {image ? (
          <img
            src={image}
            alt={`${title} preview`}
            loading="lazy"
            className="h-full w-full object-contain p-3"
          />
        ) : (
          <ProjectCover title={title} tech={tech} />
        )}
        {featured && (
          <span className="chip absolute left-3 top-3 bg-accent/20 text-accent-soft">
            Featured
          </span>
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-4 p-6">
        <h3 className="font-display text-lg font-semibold text-ink sm:text-xl">
          {title}
        </h3>
        <p className="flex-1 text-sm leading-relaxed text-ink-muted">{description}</p>

        <div className="flex flex-wrap gap-2">
          {tech.map((t) => (
            <span key={t} className="chip font-mono text-[0.72rem]">
              {t}
            </span>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 pt-1">
          {github && (
            <a
              href={github}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost !py-2 !px-3 text-sm"
            >
              <BsGithub /> Code
            </a>
          )}
          {hasDemo && (
            <a
              href={demo}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary !py-2 !px-3 text-sm"
            >
              Live demo <BsArrowUpRight />
            </a>
          )}
        </div>
      </div>
    </article>
  );
}

export default ProjectCards;
